module.exports = __webpack_public_path__ + "images/6685b956.png";